import { useGlobalStore } from '@/stores/global';
import { queryOptions } from '@tanstack/vue-query';

export type Personality = {
  gradients: [string, string];
};

export type PersonalityMap = Record<string, Personality>;

async function getPersonalityGradients() {
  const globalStore = useGlobalStore();
  const res = await fetch(`${globalStore.assets_cdn_url}/static-data/personality.json`);
  const data = (await res.json()) as PersonalityMap;
  return data;
}

export const personalityQueryOptions = queryOptions({
  queryKey: ['personality'],
  queryFn: getPersonalityGradients,
}); 
